// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-83047710","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"indentedSyntax":true,"sourceMap":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/presets/tool/api/marketplace/cnova/CategorizationAddItem.vue
// module id = 1860
// module chunks = 0